module.exports = "<div>\n  <h1>Found in {{ $ctrl.name }}.html</h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/home/home.html
// module id = 563
// module chunks = 0